/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiCallOut, EuiFlexItem } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { DocLink } from '@modules/doclinks'
import { useFlagsWhenLoaded } from '@modules/launchdarkly'

import messages from './messages'

import type { FunctionComponent } from 'react'

export const GenerateKeyWarning: FunctionComponent = () => {
  const [_, flags] = useFlagsWhenLoaded()
  const isUIAMEnabled = flags.uiamUi

  if (isUIAMEnabled) {
    return null
  }

  return (
    <EuiFlexItem>
      <EuiCallOut
        color='warning'
        title={<FormattedMessage {...messages.assignRolesHelpTextTitle} />}
        announceOnMount={true}
      >
        <FormattedMessage
          {...messages.assignRolesHelpText}
          values={{
            kibanaLink: (
              <DocLink link='apiKeysKibanaLink'>
                <FormattedMessage {...messages.kibanaText} />
              </DocLink>
            ),
            elasticsearchLink: (
              <DocLink link='apiKeysElasticsearchLink'>
                <FormattedMessage {...messages.elasticsearchText} />
              </DocLink>
            ),
          }}
        />
      </EuiCallOut>
    </EuiFlexItem>
  )
}
